/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ switchAccounts: NonNullable<unknown> }} Signup_Switch_AccountsInputs */

const en_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wrong account? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>Switch Accounts</a>`)
};

const fr_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mauvais compte ? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>Changer de Compte</a>`)
};

const de_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falsches Konto? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>Konto wechseln</a>`)
};

const it_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Account sbagliato? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>Cambia account</a>`)
};

const ru_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Неправильный аккаунт? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>Сменить аккаунт</a>`)
};

const es_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cuenta incorrecta? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>Cambiar de cuenta</a>`)
};

const zh_cn2_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`账户错误？<a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>切换账户</a>`)
};

const ja_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アカウントが間違っていますか？<a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>アカウントを切り替える</a>`)
};

const hi_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`गलत खाता? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>खाता बदलें</a>`)
};

const pt_pt2_signup_switch_accounts = /** @type {(inputs: Signup_Switch_AccountsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conta errada? <a href="#!/" class="link-accent" onclick=${i?.switchAccounts}>Trocar de conta</a>`)
};

/**
* | output |
* | --- |
* | "Wrong account? <a href=\"#!/\" class=\"link-accent\" onclick={switchAccounts}>Switch Accounts</a>" |
*
* @param {Signup_Switch_AccountsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_switch_accounts = /** @type {((inputs: Signup_Switch_AccountsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Switch_AccountsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_switch_accounts(inputs)
	if (locale === "de") return de_signup_switch_accounts(inputs)
	if (locale === "it") return it_signup_switch_accounts(inputs)
	if (locale === "ru") return ru_signup_switch_accounts(inputs)
	if (locale === "es") return es_signup_switch_accounts(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_switch_accounts(inputs)
	if (locale === "ja") return ja_signup_switch_accounts(inputs)
	if (locale === "hi") return hi_signup_switch_accounts(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_switch_accounts(inputs)
	return en_signup_switch_accounts(inputs)
});